import type { EarthlyBranch } from '../types/branches';
import type { Relation } from '../types/relations';
import type { PillarPosition } from '../types/pillars';
import { branchIndex } from '../core/sexagenary';
import { isAdjacentPillar } from './adjacent';

// 육충: branches exactly 6 apart
// 子午, 丑未, 寅申, 卯酉, 辰戌, 巳亥
// 인접 기둥(연-월, 월-일, 일-시)에서만 충 발생
export const CLASHES: [number, number][] = [
  [0, 6],  // 子↔午
  [1, 7],  // 丑↔未
  [2, 8],  // 寅↔申
  [3, 9],  // 卯↔酉
  [4, 10], // 辰↔戌
  [5, 11], // 巳↔亥
];

export function findEarthlyClashes(
  branches: { branch: EarthlyBranch; position: PillarPosition }[]
): Relation[] {
  const relations: Relation[] = [];

  for (let i = 0; i < branches.length; i++) {
    for (let j = i + 1; j < branches.length; j++) {
      if (!isAdjacentPillar(branches[i].position, branches[j].position)) continue;
      const a = branchIndex(branches[i].branch);
      const b = branchIndex(branches[j].branch);

      for (const [s1, s2] of CLASHES) {
        if ((a === s1 && b === s2) || (a === s2 && b === s1)) {
          const [first, second] = a === s1 ? [branches[i], branches[j]] : [branches[j], branches[i]];
          relations.push({
            type: '육충',
            pillars: [branches[i].position, branches[j].position],
            branches: [first.branch, second.branch],
            description: `${first.branch}${second.branch}충`,
          });
        }
      }
    }
  }

  return relations;
}
